import { BaseService } from 'services/baseService';
import { Notification } from 'types/Notification';

class NotificationService extends BaseService<Notification> {
  controllerName = 'notification';
}

export const notificationService = new NotificationService();
